export const authentication = {
  confirmEmail: {
    anActivationEmailHasBeenSent: '激活链接已发送，请验证您的电子邮件',
    weHaveSentActivationLinkToEmailAddress: '我们已向电子邮件地址发送了激活链接',
    toVerifyYourAccount: `以'验证您的帐户'。`,
    onceVerifiedAutomaticallyRedirected: '验证后，您将自动重定向到面板。',
    didNotReceiveAnEmail: `没有收到电子邮件？请检查您的垃圾邮件文件夹`,
    resendIn: '在',
    seconds: '秒内重新发送',
    resend: '重新发送',
    backToSignUp: '返回注册',
    greatPleaseCheckYourMessage: '太好了，请检查您的电子邮件',
    weHaveSentEmailTo: '我们已向以下地址发送了电子邮件',
    withALinkToReset: ' ，其中包含重置您的帐户的链接。激活后，您将能够完成帐户创建并开始您的免费试用。',
    resent: '已重新发送',
    backToLogin: '返回登录',
  },
  forgotPassword: {
    forgotPassword: '忘记密码？',
    noWorries: '别担心，',
    weWillSendYouResetPasswordInstructions: '我们将向您发送重置密码的说明',
    workEmail: '工作电子邮件',
    continue: '继续',
    backToLogin: '返回登录',
    placeholders: {
      enterYourEmail: '输入您的电子邮件',
    }
  },
  logout: {
    logout: '退出登录',
    wantToLogOut: '确定要退出登录吗？',
    yesIWillBeBack: '是的，我会回来',
    cancel: '取消',
  },
  newPassword: {
    createNewPassword: '创建新密码',
    yourNewPasswordMustBeDifferent: '您的新密码必须与先前使用的密码不同。',
    password: '密码',
    confirmPassword: '确认密码',
    setPassword: '设置密码',
    signUp: '注册',
    login: '登录',
    backTo: '返回',
    setAPassword: '设置密码',
    setNewPasswordToYourAccount: '为了安全和隐私目的，在您的帐户上设置一个新密码',
    backToSignUp: '返回注册',
    placeholders: {
      enterYourPassword: '输入您的密码',
    }
  },
  resetPassword: {
    passwordReset: '重置密码',
    yourPasswordHasBeenSuccessfullyReset: '您的密码已成功重置。',
    clickBelowToLogIn: '点击下方登录',
    continueToLogin: '继续登录',
  },
  newSignUp: {
    welcomeBack: '欢迎回来',
    to: '到',
    logIn: '登录',
    as: '作为',
    withFacebook: '使用Facebook登录',
    logInWithGoogle: '使用Google登录',
    or: '或',
    pleaseFillAValidWorkEmail: '请填写有效的工作电子邮件*',
    workEmailIsRequired: '工作电子邮件是必需的*',
    pleaseFillAValidPassword: '请填写有效的密码*',
    passwordIsRequired: '密码是必需的*',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    login: '登录',
    doNotHaveAnAccount: '还没有帐户？',
    setUpAFreeAccount: '设置一个免费帐户',
    noCreditCardRequired: '无需信用卡',
    cancelAnytime: '随时取消',
    signUp: '注册',
    signUpWithGoogle: '使用Google注册',
    emailIsAlreadyRegistered: '该电子邮件已在我们这里注册，请点击登录继续',
    phoneNumberShouldHaveMinimum7Digits: '电话号码应至少为7位*',
    phoneNumberIsRequired: '电话号码是必需的*',
    passwordMustContain: '密码必须包含',
    atleast6Characters: '至少6个字符，',
    oneUpperCaseLetter: '1个大写字母',
    oneSpecialCharacter: '1个特殊字符*',
    alreadyHaveAccount: '已经有一个帐户？',
    signingUpToBotPenguinIsAConsentToOur: '注册BotPenguin帐户即表示您同意我们的',
    privacyPolicy: '隐私政策',
    termsAndConditions: '条款和条件',
    and: ' 和 ',
    english: '英语',
    hindi: '印地语',
    german: '德语',
    french: '法语',
    portuguese: '葡萄牙语',
    spanish: '西班牙语',
    italian: '意大利语',
    russian: '俄语',
    placeholders: {
      workEmail: '工作电子邮件*',
      password: '密码*',
      phone: '电话*',
    }
  },
  unsubscribe: {
    successfullyUnsubscribed: '成功取消订阅',
    yourEmail: '您的电子邮件',
    haveBeenSuccessfullyUnsubscribedFrom: ' 已成功取消订阅',
    backToLogin: '返回登录'
  }
};
